<div class="main">
  <div ngStyle.xs="padding-inline:0" fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="10"
    fxLayoutGap.xs="0" fxLayoutGap.sm="0" class="adver main_ads ">
    <div fxFlexAlign="center" class="ad_div hide_ad_mobile " fxLayoutAlign="center">
      <div id="AADIV42"></div>
      <!-- <a href="https://bit.ly/3M4T8i3" target="_blank" rel="noopener">
        <img loading="lazy" style="display: block; width: 100%;   margin:auto"
          src.md="https://cdn.newsfirst.lk/advertisements/15-05-2023/dialog_lap.jpg"
          src.xl="https://cdn.newsfirst.lk/advertisements/15-05-2023/dialog_lap.jpg"
          src.lg="https://cdn.newsfirst.lk/advertisements/15-05-2023/dialog_lap.jpg"
          src.xs="https://cdn.newsfirst.lk/advertisements/15-05-2023/dialog_mobile.jpg"
          src.sm="https://cdn.newsfirst.lk/advertisements/15-05-2023/dialog_mobile.jpg" alt="" /></a> -->
    </div>

    <div fxFlexAlign="center" class="ad_div  hide_ad_lap " fxFlex.lg="50" fxFlex.xl="50" fxFlex.md="50" fxFlex.xs="100"
      fxFlex.sm="100" fxLayoutAlign="center">
      <div id="AADIV39"></div>
    </div>
  </div>

  <div class="padding">
    <!-- =============================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
      style="margin-bottom: 20px;">
      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3672728637886288"
        crossorigin="anonymous"></script>
      <!-- 970x90 -->
      <ins class="adsbygoogle" style="display:inline-block;width:970px;height:90px;"
        data-ad-client="ca-pub-3672728637886288" data-ad-slot="6015779906"></ins>
      <script>
        (adsbygoogle = window.adsbygoogle || []).push({});
      </script>
    </div>
    <!-- =============================================== -->

    <div fxLayout="row" fxLayoutGap="10" fxLayout.sm="column" fxLayout.xs="column">
      <div fxFlex="80" fxFlex.xs="100" fxFlex.sm="100">
        <div class="main_div">
          <div *ngIf="newsPost?.video_post==null" style="position: relative;">
            <img id="post_img" style="width: 100%;position: relative;" src={{newsPost?.images.news_detail_image}}
              alt={{newsPost?.short_title}}>
            <div *ngIf="notfound==true" style="width: max-content; height: 50px;font-size: 20px;
              background-color: #42A5F5;text-align: center;justify-content: center;position: absolute;
              bottom: 0;margin: auto;">
              <h1 class="display-flex" style="
              height: 100%;
              margin-inline: 10px;color: #FFFFFF;"> Page Not
                Found</h1>
            </div>
          </div>
          <div *ngIf="newsPost?.video_post!=null" class="video-h-title">
            <iframe width="100%" height="100%" [src]="url" title="" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
          </div>
          <div style="padding-inline: 30px;" class="padding">
            <div>
              <div *ngIf="notfound!=true">
                <h1 class="top_stories_header_news">{{newsPostTitle?.title.rendered}}
                </h1>
                <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
                  <div fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" class="author_main">{{author}}
                    <span style="display: block;">{{post_date}}</span>
                  </div>
                  <div fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" style="justify-content:end ; display: flex;">
                    <div class="share_img_div">

                      <!-- <div fxFlex="1 1 auto">
                        <a href="mailto:?subject={{newsPost?.title.rendered}}&amp;body=Check out this site https://english.newsfirst.lk/{{newsPost?.post_url}}."
                          title="Share by Email">
                          <img class="share_img"
                            src="https://storage.googleapis.com/cdn-newsfirst-lk-v2/statics/instagram_2.png" alt="">
                        </a>
                      </div> -->

                      <div fxFlex="1 1 auto" (click)="shareFB(newsPost.post_url)" style="cursor: pointer;">
                        <a title="Share via Facebook">
                          <img class="share_img"
                            src="https://storage.googleapis.com/cdn-newsfirst-lk-v2/statics/facebook_2.png" alt="">
                        </a>
                      </div>

                      <div fxFlex="1 1 auto">
                        <a href="https://twitter.com/intent/tweet?url={{newsPost?.title.rendered}} https%3a%2f%2fenglish.newsfirst.lk%2f{{newsPost?.post_url}}"
                          onclick="window.open(this.href,'window','width=640,height=480,resizable,scrollbars') ;return false;"
                          target="_blank" title="Share via X">
                          <img class="share_img"
                            src="https://storage.googleapis.com/cdn-newsfirst-lk-v2/statics/twitter.png" alt="">
                        </a>
                      </div>

                      <div fxFlex="1 1 auto">
                        <a href="https://api.whatsapp.com/send?text=https://english.newsfirst.lk/{{newsPost?.post_url}}"
                          onclick="window.open(this.href,'window','width=640,height=480,resizable,scrollbars') ;return false;"
                          data-action="share/whatsapp/share" target="_blank" title="Share via WhatsApp">
                          <img class="share_img"
                            src="https://storage.googleapis.com/cdn-newsfirst-lk-v2/statics/whatsapp_2.png" alt="">
                        </a>
                      </div>
                      <div fxFlex="1 1 auto">
                        <a aria-label="Show an example snack-bar" [cdkCopyToClipboard]="value" (click)="copyUrl()"
                          target="_blank" rel="noopener" title="Copy Link">
                          <img class="share_img"
                            src="https://storage.googleapis.com/cdn-newsfirst-lk-v2/statics/copy%20link%20(1).png "
                            alt="">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <mat-divider style="margin-block: 15px;"></mat-divider>
              </div>

              <div id="testId" class="new_details" [innerHTML]="postContent">
              </div>
              <h1 *ngIf="notfound==true" id="countdown">
              </h1>

              <!-- <div *ngFor="let item of youtubePost"> -->
              <!-- <iframe *ngIf="yt" style="width:100%; " class="video-h" [src]="youtubePost" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen></iframe> -->
              <!-- </div> -->

              <!-- <div *ngFor="let item of twitterPost">
                <blockquote class="twitter-tweet">
                  <p lang="en" dir="ltr"> <a href={{item}}></a>.
                  </p>
                </blockquote>
                <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
              </div> -->

              <!-- <div fxLayout="row" style="width: 100%; display: flex;justify-content: center;align-items: center;"
                fxLayoutGap="3" *ngFor="let items of totalImg">
                <div flex=1 *ngFor="let item of items">
                  <a href={{item}}>
                    <img style="max-width:100%;" [src]="item" alt="img">
                  </a>
                </div>

              </div> -->
              <!-- <div style="width: 100%; display: flex;justify-content: center;align-items: center;"
                *ngFor="let item of postImage">
                <a href={{item}}>
                  <img style="max-width:100%" [src]="item" alt="img">
                </a>
              </div> -->
            </div>

          </div>
        </div>
        <div>
          <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20" style="margin-top: 20px"
            class="adver">
            <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.xs="100" fxFlex.sm="100"
              fxLayoutAlign="center">
              <div class="ads_lap_hide" id="block_4404" style="max-height:90px !important;width: 100% !important;">
              </div>
              <div class="ads_mobile_hide" id="block_5077"></div>
            </div>
          </div>
          <!-- ====================================================== -->
          <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
            style=" margin-top: 10px;">
            <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
              ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
              <!-- <ins class="adsbygoogle" style="display:block;max-width: 728px;" data-ad-client="ca-pub-5432073672371728"
                data-ad-slot="1155259484" data-ad-format="auto" data-full-width-responsive="true"></ins> -->


            </div>
            <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
              ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
              <ins class="adsbygoogle" style="display:inline-block;width:920px;height:90px"
                data-ad-client="ca-pub-5432073672371728" data-ad-slot="7081168074"></ins>

            </div> -->
          </div>
          <!-- ====================================================== -->
        </div>

        <div>
          <div class="black_header">
            <h2 class="black_header_title display-flex">Other Articles</h2>
          </div>
          <div class="main_div">
            <div style="padding: 10px;" fxLayout="column">
              <div fxFlex="auto">
                <div fxLayout="row" fxLayout.xs="column" fxFlex="auto" fxLayoutGap="10">
                  <div *ngFor="let item of otherNews |slice:0:3" (click)="postId(item.id)">
                    <a href="/{{item.post_url}}">
                      <div>
                        <img style="width: 100%;" [src]="item.images.mobile_banner" alt={{item?.short_title}}>
                      </div>
                      <h2 style="margin-block: 10px; width: 100%;" class="top_stories_sub_header">{{item.short_title}}
                      </h2>
                    </a>
                  </div>
                </div>
              </div>
              <mat-divider style="margin-block: 20px;"></mat-divider>
              <div fxFlex="auto">
                <div fxLayout="row" fxLayout.xs="column" fxFlex="auto" fxLayoutGap="10">
                  <div *ngFor="let item of otherNews  |slice:3:6" (click)="postId(item.id)">
                    <a href="/{{item.post_url}}">
                      <div>
                        <img style="width: 100%;" [src]="item.images.mobile_banner" alt={{item?.short_title}}>
                      </div>
                      <h2 style="margin-block: 10px; width: 100%;" class="top_stories_sub_header">{{item.short_title}}
                      </h2>
                    </a>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>

        <!-- ====================================================== -->
        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
          style=" margin-top: 10px;">
          <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
            ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
            <!-- <ins class="adsbygoogle" style="display:block;max-width: 728px;" data-ad-client="ca-pub-5432073672371728"
              data-ad-slot="1155259484" data-ad-format="auto" data-full-width-responsive="true"></ins> -->


          </div>
          <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
              ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
              <ins class="adsbygoogle" style="display:inline-block;width:920px;height:90px"
                data-ad-client="ca-pub-5432073672371728" data-ad-slot="7081168074"></ins>

            </div> -->
        </div>
        <!-- ====================================================== -->
      </div>
      <div fxFlex="20" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
        <div>
          <div style="margin-bottom: 10px; width: 100%;    position: relative;">
            <!-- Hello AI -->
            <a href="https://news1st.lk/3Gj4Jv2" target="_blank">
              <img
                style="max-width: 100%;    margin: auto;  display: flex;  justify-content: end;margin-bottom: 10px; max-width: 300px; "
                src="https://cdn.newsfirst.lk/advertisements/12-06-2025/mobitel_en.jpeg" alt="">
            </a>

            <!-- 1298 -->
            <a href="https://news1st.lk/4eufaIz " target="_blank">
              <img
                style="max-width: 100%;    margin: auto;  display: flex;  justify-content: end;margin-bottom: 10px; max-width: 300px; "
                src="https://cdn.newsfirst.lk/advertisements/25-06-2025/330_330%20-%20E.jpg" alt="">
            </a>

            <!-- 1598 -->
            <a href="https://mobitel.lk/mobitel-1598" target="_blank">
              <img
                style="max-width: 100%;    margin: auto;  display: flex;  justify-content: end;margin-bottom: 10px; max-width: 300px; "
                src="https://cdn.newsfirst.lk/advertisements/13-05-2025/330_330%20-%20E.png" alt="">
            </a>
            <!-- 1598 new -->
            <a href="https://l.ead.me/mobitel1598" target="_blank">
              <img
                style="max-width: 100%;    margin: auto;  display: flex;  justify-content: end;margin-bottom: 10px; max-width: 300px; "
                src="https://cdn.newsfirst.lk/advertisements/15-10-2025/330%20x%20330.jpg" alt="">
            </a>


          </div>
          <div style="position: relative; width: 100%;margin-bottom: 10px;">
            <script async
              src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5432073672371728"
              crossorigin="anonymous"></script>
            <!-- 250x600 NEW WEB -->
            <ins class="adsbygoogle" style="display:inline-block;width:250px;height:600px"
              data-ad-client="ca-pub-5432073672371728" data-ad-slot="9587877105"></ins>
            <script>
              (adsbygoogle = window.adsbygoogle || []).push({});
            </script>

          </div>
          <!-- <div class="mobile_ads" fxFlexAlign="center" fxLayoutAlign="center" style=" margin-bottom: 10px;  ">
            <div id="block_4921" style="    width: 100%;  overflow: hidden;"></div>
          </div> -->
          <div class="mobile_ads" fxFlexAlign="center" fxLayoutAlign="center" style=" margin-bottom: 10px;  ">
            <div id="block_4405" style="width: 100%;  overflow: hidden;"></div>
          </div>
          <div>
            <div class="black_header">
              <h2 class="black_header_title display-flex">Featured News</h2>
            </div>
            <div class="web">
              <div style="background-color: #FFFFFF;border: 1px solid #CCCCCC; ">
                <div style="padding: 10px; cursor: pointer;" *ngFor="let item of featuredsNews |slice:0:5; let i=index "
                  (click)="postId(item.id)">
                  <a href="/{{item.post_url}}">
                    <div>
                      <img style="width: 100%;" [src]="item.images.mobile_banner" alt={{item?.short_title}}>
                    </div>
                    <h2 style="margin-block: 10px; width: 100%;" class="top_stories_sub_header">{{item.short_title}}
                    </h2>
                  </a>
                  <mat-divider></mat-divider>
                </div>
              </div>
            </div>
            <div class="mobile">
              <div style="overflow-x: auto;background-color: #FFFFFF;border: 1px solid #CCCCCC; ">
                <div style="margin: 10px;">
                  <div style="display: inline-flex ;margin-right: 10px;" fxLayoutGap="10">
                    <div style="width: 250px;" *ngFor="let item of featuredsNews  |slice:0:5" (click)="postId(item.id)">
                      <a href="/{{item.post_url}}">
                        <div>
                          <img style="width: 100%;" [src]="item.images.mobile_banner" alt={{item?.short_title}}>
                        </div>
                        <h2 style="margin-block: 10px; width: 100%;" class="top_stories_sub_header">{{item.short_title}}
                        </h2>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- =============================================== -->
            <div style="margin-top: 10px;">

              <!-- <ins class="adsbygoogle" style="display:block;max-width: 300px;" data-ad-client="ca-pub-5432073672371728"
                data-ad-slot="5365967236" data-ad-format="auto" data-full-width-responsive="true"></ins> -->

            </div>
            <!-- =============================================== -->

          </div>

          <div>
            <script async
              src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5432073672371728"
              crossorigin="anonymous"></script>
            <!-- 250x600 NEW WEB -->
            <ins class="adsbygoogle" style="display:inline-block;width:250px;height:600px;"
              data-ad-client="ca-pub-5432073672371728" data-ad-slot="9587877105"></ins>
            <script>
              (adsbygoogle = window.adsbygoogle || []).push({});
            </script>

          </div>
        </div>
      </div>
    </div>
    <!-- ====================================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
      style=" margin-top: 10px;">
      <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
        ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
        <!-- <ins class="adsbygoogle" style="display:block;width: 100%;" data-ad-client="ca-pub-5432073672371728"
          data-ad-slot="1155259484" data-ad-format="auto" data-full-width-responsive="true"></ins> -->

        <!-- <div style="max-height:90px !important">
            <script async
              src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3672728637886288"
              crossorigin="anonymous"></script>

            <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-3672728637886288"
              data-ad-slot="7381577559" data-ad-format="auto" data-full-width-responsive="true"></ins>
            <script>      (adsbygoogle = window.adsbygoogle || []).push({}); </script>
          </div> -->
      </div>
      <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
        ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
        <ins class="adsbygoogle" style="display:inline-block;width:920px;height:90px"
          data-ad-client="ca-pub-5432073672371728" data-ad-slot="7081168074"></ins>

      </div> -->
    </div>
    <!-- ====================================================== -->

    <!-- =============================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver margin"
      style=" margin-bottom: 20px;">



      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3672728637886288"
        crossorigin="anonymous"></script>
      <!-- Responsive horizontal -->
      <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-3672728637886288" data-ad-slot="2741545695"
        data-ad-format="auto" data-full-width-responsive="true"></ins>
      <script>
        (adsbygoogle = window.adsbygoogle || []).push({});
      </script>



      <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center">
        <div class="ads_lap_hide" id="block_5086" style="max-height:90px !important;width: 100% !important;"></div>
        <div class="ads_mobile_hide" id="block_5076"></div>
      <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center">
        <div class="ads_lap_hide" id="block_5085" style="max-height:90px !important;width: 100% !important;"></div>
        <div class="ads_mobile_hide" id="block_5077"></div>
      </div> -->
    </div>
    <!-- =============================================== -->


  </div>
</div>